export default "__VITE_ASSET__Ctkzpt$Q__"